export function maskBrazilPhone(input) {
  const digitsOnly = input.replace(/\D/g, '');
  if (digitsOnly.length === 4) return input;
  if (digitsOnly.length === 2) return '+55 (';
  const core = digitsOnly.startsWith('55') ? digitsOnly.slice(2) : digitsOnly;
  const p = core.slice(0, 11);
  const ddd = p.slice(0, 2); 
  const part1 = p.slice(2, 7);
  const part2 = p.slice(7, 11);
  let result = '+55';
  if (ddd.length > 0) {
    result += ` (${ddd}`;
    if (ddd.length === 2) result += ')';
  }
  if (part1.length > 0) {
    if (ddd.length === 2) result += ' ';
    result += part1;
  }
  if (part2.length > 0) {
    result += `-${part2}`;
  }

  return result;
}